const cleanAllPaymentData = () => {
};

export default {
  cleanAllPaymentData,
};
